'use client'

import React from 'react'

import { Footer, Header, Main, PageWrapper } from 'Components/Blocks'
import {
  AgencyHeroSection,
  FaqSection,
  OurNotoriousCasesSection,
  StartupCraftProcessSection,
  WeHavePerfectReputationSection,
  WeLiveUpToOurReputationSection,
} from 'Components/Sections'
import { AllFaqPagesData, HomePageData } from 'Data/types'

type Props = {
  faqData: AllFaqPagesData
  homePageData: HomePageData
}

function AgencyPage({ faqData, homePageData }: Props) {
  return (
    <PageWrapper>
      <Header />

      <Main>
        <AgencyHeroSection />

        <WeHavePerfectReputationSection py={[17]} />

        <OurNotoriousCasesSection pt={[17]} />

        <StartupCraftProcessSection py={[17]} />

        <WeLiveUpToOurReputationSection
          py={[17]}
          videoFullUrl={homePageData.homePage?.videoFullUrl}
        />

        <FaqSection data={faqData} pb={[14, 14, 11]} pt={[11, 11, 17]} />
      </Main>

      <Footer />
    </PageWrapper>
  )
}

export type { Props }
export default AgencyPage
